import { namespace } from 'vuex-class';
import { IDocumentActionsState } from './document-actions.types';

export const DocumentActions = namespace('documentActions');

export function getDefaultState(): IDocumentActionsState {
  return {
    document: null,
    loadDocumentFailed: false,
    updatedDocument: null,
    loading: false,
    error: false,
    done: false,
    newVersionDocumentId: null,
    sentEmail: null,
    documentEvents: null,
  };
}

export enum EDocumentActionsAction {
  Reset = 'reset',
  ResetLoadingState = 'resetLoadingState',
  LoadDocument = 'loadDocument',
  LoadDocumentSuccess = 'loadDocumentSuccess',
  LoadDocumentFailed = 'loadDocumentFailed',
  UpdateExpirationDate = 'updateExpirationDate',
  SendEmailReminder = 'sendEmailReminder',
  SendEmailReminderSuccess = 'sendEmailReminderSuccess',
  Recall = 'recall',
  RecallSuccess = 'recallSuccess',
  Delete = 'delete',
  DeleteSuccess = 'deleteSuccess',
  SendSMSReminder = 'sendSMSReminder',
  SendSMSReminderSuccess = 'sendSMSReminderSuccess',
  SendSMSToRecipient = 'sendSMSToRecipient',
  SendSMSToRecipientSuccess = 'sendSMSToRecipientSuccess',
  SendVideoReminder = 'sendVideoReminder',
  SendVideoReminderSuccess = 'sendVideoReminderSuccess',
  UpdateContactNumbers = 'updateContactNumbers',
  CreateNewVersion = 'createNewVersion',
  UploadSigned = 'uploadSigned',
  UploadSignedSuccess = 'uploadSignedSuccess',
  CreateNewVersionSuccess = 'createNewVersionSuccess',
  UpdateScheduledSendingTime = 'updateScheduledSendingTime',
  UpdateDocument = 'updateDocument',
  UpdateDocumentSuccess = 'updateDocumentSuccess',
  ChangeOwner = 'changeOwner',
  ChangeOwnerSuccess = 'changeOwnerSuccess',
  CancelScheduledSending = 'cancelScheduledSending',
  CancelScheduledSendingSuccess = 'cancelScheduledSendingSuccess',
  MarkAsLost = 'markAsLost',
  MarkAsLostSuccess = 'markAsLostSuccess',
  ResetError = 'resetError',
  Error = 'Error',
  LoadSentEmail = 'loadSentEmail',
  LoadDocumentEvents = 'loadDocumentEvents',
  SetDocument = 'setDocument',
}

export enum EDocumentActionsMutation {
  SetState = 'setState',
  SetLoading = 'setLoading',
  SetError = 'setError',
  SetDone = 'setDone',
  SetDocument = 'setDocument',
  SetLoadDocumentFailed = 'setLoadDocumentFailed',
  SetUpdatedDocument = 'setUpdatedDocument',
  SetNewVersionDocumentId = 'setNewVersionDocumentId',
  SetSentEmail = 'setSentEmail',
  SetDocumentEvents = 'setDocumentEvents',
}
